import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { sharedEventsUrl } from './settings';
import { BASE_URL } from './v2Api';

const SharableLink = ({ user, includeGroups, includeOnlyExciting }) => {
  const [sharableUrl, setSharableUrl] = useState('');
  const [loadingSharableLink, setLoadingSharableLink] = useState(false);
  const [userToken, setUserToken] = useState('');

  // Detect if user is on desktop
  const isDesktop = () => {
    // Check for mobile user agents - if not mobile, assume desktop
    const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return !mobileUserAgent;
  };

  const handleCreateSharableLink = async () => {
    if (!user) return;
    
    setLoadingSharableLink(true);
    
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(`${BASE_URL}/get_user_settings`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to get user settings');
      }

      const settings = await response.json();
      setUserToken(settings.sharable_token);
      
      // Create Dust URL with proper encoding
      const baseUrl = `${sharedEventsUrl}?token=${settings.sharable_token}&includeGroups=${includeGroups}&includeOnlyExciting=${includeOnlyExciting}`;
      const encodedUrl = encodeURIComponent(baseUrl);
      const dustUrl = `https://dust.events?planner-events=${encodedUrl}`;
      setSharableUrl(dustUrl);
    } catch (error) {
      console.error('Error creating sharable link:', error);
      alert('Failed to create sharable link. Please try again.');
    } finally {
      setLoadingSharableLink(false);
    }
  };

  const regenerateUrl = () => {
    if (userToken) {
      const baseUrl = `${sharedEventsUrl}?token=${userToken}&includeGroups=${includeGroups}&includeOnlyExciting=${includeOnlyExciting}`;
      const encodedUrl = encodeURIComponent(baseUrl);
      const dustUrl = `https://dust.events?planner-events=${encodedUrl}`;
      setSharableUrl(dustUrl);
    }
  };

  // Auto-generate the Dust URL when component mounts
  React.useEffect(() => {
    if (user && !sharableUrl) {
      handleCreateSharableLink();
    }
  }, [user]);

  // Regenerate URL when parameters change (without API call)
  React.useEffect(() => {
    if (userToken) {
      regenerateUrl();
    }
  }, [includeGroups, includeOnlyExciting]);

  if (loadingSharableLink) {
    return (
      <div className="sharable-link-container dont-print">
        <p>Generating Dust export link...</p>
      </div>
    );
  }

  if (!sharableUrl) {
    return null;
  }

  return (
    <div className="sharable-link-container dont-print">
    
      {isDesktop() ? (
        <>
          <h3>Scan to export your picks to Dust for mobile access during Burning Man:</h3>
          <QRCodeSVG value={sharableUrl} size={200} />
        </>
      ) : (
        <div className="dust-export-actions">
          <a 
            href={sharableUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="open-dust-button"
          >
            📱 Export to Dust App
          </a>
        </div>
      )}

      <p>* <strong><a href="https://dust.events" target="_blank" rel="noopener noreferrer">Dust</a></strong> is a mobile app with camps, events, art for navigation during Burning Man.</p>
      
    </div>
  );
};

export default SharableLink; 